import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const supplyMaterial = async (params: object) => {
  return await POST({
    url: Api.supplyMaterial,
    data: params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Content-Type': 'application/json'
    },
    dataType: 'json'
  })
}
